import { Component, EventEmitter, Input,  Output, Inject } from 'ng-metadata/core';

import './sentiment.selector.scss';

/**
 * @ngdoc directive
 * @name mwContentDocumentSentimentSelector
 * @module mw.components.contentDocuments
 * @param {string} [sentiment] - The current sentiment of the document.
 * @param {string} [sentiment-override] - The sentiment of the document, if its ever been overwritten by the user
 * @param {expression} [on-sentiment-update] - Function passed in to handle sentiment when it updates.
 * @param {expression} [on-sentiment-reset] - Function passed in to handle sentiment when the user resets it.
 *  @description
 * `mw-content-document-sentiment-menu` is responsible for showing a single select menu that lists all sentiment value options.
 * @usage
 * <hljs hls-language="html">
 *  <mw-content-document-sentiment-selector sentiment="$ctrl.document.sentiment" sentiment-override="$ctrl.document.sentimentOverride"></mw-content-document-sentiment-menu>
 * </hls>
 */
@Component({
    selector: 'mw-content-document-sentiment-selector',
    template: `
        <div class="mw-content-document-sentiment__inline-selector" layout="row" layout-align="end center" ng-mouseover="$ctrl.handleSelectorHover($event)" ng-class="{'mw-content-document-sentiment__inline-selector-show': $ctrl.triggerSelector}">
            <mw-icon-button
                ng-repeat="sentiment in $ctrl.sentimentList"
                svg-icon="{{::sentiment.icon}}"
                tooltip="{{::sentiment.name | translate}}"
                class="mw-content-document-sentiment__inline-{{sentiment.type}}"
                ng-click="$ctrl.handleSentimentSelect(sentiment.type)"
                ng-show="sentiment.type === ''? $ctrl.sentimentOverride : true"
                tooltip-direction="top">
            </mw-icon-button>
        </div>
    `
})
export class SentimentSelectorComponent {
    @Input('<') sentiment: string;
    @Input('<') sentimentOverride: string;

    @Output() onSentimentUpdate = new EventEmitter<string>();
    @Output() onSentimentReset = new EventEmitter();

    sentimentList: Array<any> = [
        { name: 'Reset', icon: 'navigation:ic_close_24px', type: '' },
        { name: 'Not rated', icon: 'meltwater:sentiment-not-rated', type: 'U' },
        { name: 'Neutral', icon: 'social:ic_sentiment_neutral_24px', type: 'N' },
        { name: 'Negative', icon: 'social:ic_sentiment_dissatisfied_24px', type: 'V' },
        { name: 'Positive', icon: 'social:ic_sentiment_very_satisfied_24px', type: 'P' },
    ]

    constructor(@Inject('$mdPanel') private $mdPanel) {
        'ngInject';
    }

    handleSentimentSelect(sentiment) {
        if (sentiment === '') {
            this.onSentimentReset.emit({});
        }else {
            this.sentimentOverride = sentiment;
            this.onSentimentUpdate.emit(this.sentimentOverride);
        }
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/content-documents/media-document/sentiment/sentiment.selector.component.ts